import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export type CMS_LINKS = {
  privacyPolicy: string;
  termsOfUse: string;
  yourPrivacyChoices: string;
};

interface GlobalModel {
  loading: boolean;
  cms_links: CMS_LINKS;
}

const initialState: GlobalModel = {
  loading: false,
  cms_links: {
    privacyPolicy: "",
    termsOfUse: "",
    yourPrivacyChoices: "",
  },
};

const globalSlice = createSlice({
  name: "globalSlice",
  initialState,
  reducers: {
    setLoading: (state: GlobalModel, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setCMSLinks: (state: GlobalModel, action: PayloadAction<CMS_LINKS>) => {
      state.cms_links = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setLoading, setCMSLinks } = globalSlice.actions;

export default globalSlice.reducer;
